const install = function (VueClass) {
    /** 全局串行执行队列，Promise 链实现：每个任务追加到链尾，前一个完成后才执行下一个 */
    let mappingQueue = Promise.resolve();
    const Bus = new VueClass({
        methods: {
            emit(event, ...args) {
                this.$emit(event, ...args);
            },
            on(event, callback) {
                this.$on(event, callback);
            },
            off(event, callback) {
                this.$off(event, callback);
            },
            enqueueMapping(task, eventName) {
                mappingQueue = mappingQueue
                    .then(() => task())
                    .catch(err => {
                    console.error(`[Bus] 任务执行失败 (事件: ${eventName})`, err);
                });
            }
        }
    });
    VueClass.prototype.$bus = Bus;
};
export default install;
